<template>
  <div class="no-gutters mr-0 pr-0">
    <table class="table-bordered table-evaluation-info">
      <tr>
        <td>
          <div class="mt-3">
            <p class="font-weight-bold mb-3">{{$t('medium_grant_ev.general__info_grid_by')}}</p>
            <div v-if="EvaluationForm.evaluation && EvaluationForm.evaluation.user">
              <div>{{EvaluationForm.evaluation.user.name}}</div>
              <small>{{EvaluationForm.evaluation.updated_at}}</small>
            </div>
            <div v-else>-</div>
          </div>
        </td>
      </tr>
      <tr height="100">
        <td valign="center">
          <h1 class="m-0 p-0">TOTAL SCORE <span class="ml-4">{{ totalScore }}</span></h1>
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
  import {EvaluationForm, UserRoles} from "@/services";

  export default {
    data() {
      return {
        EvaluationForm,
        UserRoles,
        loggedUser: {}
      }
    },
    computed: {
      totalScore: function () {
        let total = 0;
        total += EvaluationForm.model.final_score || 0;
        total = parseInt(total);

        EvaluationForm.totalScore = total;

        return total;
      }
    },
    inject: ['validateEvaluation'],
    created() {

    },
    beforeMount() {
      let vm = this;
      setTimeout(function() {
        EvaluationForm.totalScore = vm.totalScore;
      }, 200);
    },
    mounted() {
      let vm = this;
      vm.loggedUser = vm.$store.getters['Auth/loggedUser'];
    }
  }
</script>
<style lang="scss" scoped>
  .table-risk-assesment td {
    padding-bottom: 0 !important;
    padding-left: 0 !important;
  }
</style>
